import { ourPrograms as defaultPrograms } from '@/mocks/homeData';
import { useSiteData } from '@/contexts/SiteDataContext';

export default function OurPrograms() {
  const { data } = useSiteData();
  const ourPrograms = data.programs.length > 0 ? data.programs : defaultPrograms;
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-secondary-50 text-secondary-600 text-xs font-semibold rounded-full mb-3">
            Our Programs
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Holistic Approach to{' '}
            <span className="gradient-text">Social Change</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            From education to environment, our programs address the diverse needs of communities across India.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 md:gap-4">
          {ourPrograms.map((program, index) => (
            <div
              key={index}
              className="group p-5 rounded-2xl bg-background-100 hover:bg-background-50 border border-transparent hover:border-foreground-200/60 transition-all duration-300 flex flex-col items-center text-center"
            >
              <div className={`w-14 h-14 rounded-2xl ${program.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${program.icon} text-white text-2xl`}></i>
              </div>
              <h4 className="font-heading text-sm font-bold text-foreground-950 mb-1.5">{program.name}</h4>
              <p className="text-foreground-500 text-xs leading-relaxed">{program.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}